import { AlertTriangle, Shield, Home } from 'lucide-react';

const LandRightsNotice = () => {
  return (
    <div className="bg-red-600 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-start space-x-4">
            <AlertTriangle className="h-8 w-8 text-yellow-300 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-2xl font-bold mb-4">
                NOTICE TO ALL LAND AGENTS SELLING AND BUYING LAND
              </h2>
              
              <div className="bg-red-700 rounded-lg p-6 mb-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="flex items-center space-x-3">
                    <Home className="h-6 w-6 text-yellow-300" />
                    <div>
                      <p className="font-semibold text-lg">You, the buyer only own the building.</p>
                      <p className="font-semibold text-lg">You, the buyer only own the Title.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3">
                    <Shield className="h-6 w-6 text-yellow-300" />
                    <div>
                      <p className="font-semibold text-lg">
                        The land/air spectrum/Taku Tai Moana belongs to the hapū/whānau of that rohe.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4 text-lg">
                <p>
                  <strong>Those in occupation of hapū/whānau land are now liable to pay rent to hapū/whānau of that rohe. (1986)</strong>
                </p>
                
                <p>
                  Land rentals will be liable to pay rent from today to hapū/whānau in the future. On all whenua.
                </p>
                
                <div className="bg-red-700 rounded-lg p-4 mt-6">
                  <h3 className="font-bold text-xl mb-3">Constitutional Foundation:</h3>
                  <ul className="space-y-2">
                    <li>• He Whakaputanga o te Rangatiratanga 1835</li>
                    <li>• Te Tiriti o Waitangi 1840</li>
                    <li>• 1852 Constitution Act Section 71</li>
                    <li>• Te Ture Whenua Māori Act 1993</li>
                  </ul>
                </div>
                
                <p className="text-yellow-100 font-medium">
                  This notice is based on the constitutional rights established by He Whakaputanga 1835 
                  and Te Tiriti o Waitangi 1840, which recognize hapū/whānau as the rightful guardians 
                  and owners of their ancestral lands.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandRightsNotice;